import {useCallback, useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {setIsAcquiringGeoCoordinates} from 'modules/meta/slice'
import {getIsUserLocationSearch} from 'modules/search/selectors'
import {GeolocationPermissions} from 'utils/geolocation'

import {useSetDeviceGeolocationSearchParams} from './useSetDeviceGeolocationSearchParams'

export const useHandleUserGeolocation = async () => {
  let currentPermissionStatus = null
  const isUserLocationSearch = useSelector(getIsUserLocationSearch)

  const {setDeviceGeolocationSearchParams} =
    useSetDeviceGeolocationSearchParams()

  const dispatch = useDispatch()

  const handleGeolocationRequest = useCallback(async () => {
    setDeviceGeolocationSearchParams()
  }, [isUserLocationSearch])

  useEffect(() => {
    if (isUserLocationSearch) {
      handleGeolocationRequest()
    }
  }, [isUserLocationSearch])

  useEffect(() => {
    if (navigator.permissions) {
      navigator.permissions
        .query({name: 'geolocation'})
        .then(permissionStatus => {
          currentPermissionStatus = permissionStatus.state
          permissionStatus.onchange = handlePermissionStatusChange
        })
    }
  }, [])

  const handlePermissionStatusChange = ev => {
    const newPermissionState = ev.target.state

    // We want to make sure to trigger this only when users are asking for the first time to enable location services
    if (
      newPermissionState === GeolocationPermissions.GRANTED &&
      currentPermissionStatus === GeolocationPermissions.PROMPT
    ) {
      dispatch(setIsAcquiringGeoCoordinates(true))
    }

    currentPermissionStatus = newPermissionState
  }
}
